import { render, staticRenderFns } from "./LoginScreen.vue?vue&type=template&id=36a501fc&scoped=true&lang=pug"
import script from "./LoginScreen.vue?vue&type=script&lang=ts"
export * from "./LoginScreen.vue?vue&type=script&lang=ts"
import style0 from "./LoginScreen.vue?vue&type=style&index=0&id=36a501fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a501fc",
  null
  
)

export default component.exports